import { useEffect } from 'react';
import { get } from 'lodash-es';
import { useFetch } from 'srcAlias/utils/useFetch';
import { getApiEndpoint } from 'srcAlias/utils/url';
import { createHeaders } from 'srcAlias/utils/headers';
import config from 'configAlias';
import { useSelector } from 'react-redux';
import { selectSessionId } from 'srcAlias/client/state/selectors';

export const useEligibilityCall = (setEligibilityResponse) => {
  const appConfig = get(config, 'appConfig', {});
  const sessionId = useSelector(selectSessionId);

  const headersDetails = {
    channelId: get(appConfig, 'channelId'),
    sessionId: sessionId,
    countryCode: get(appConfig, 'countryCode'),
    groupMember: get(appConfig, 'groupMember'),
    appEIMId: get(appConfig, 'appEIMId'),
  };

  const apiDomain = getApiEndpoint();
  const apiEndpoint =
    process.env.REACT_APP_CREATE_MOCK_SERVER === 'true'
      ? 'api/v0/investment-eligibilities'
      : process.env.REACT_APP_ELIGIBILITY_CHECKING_URL;
  const timeoutOptions = {
    min: get(appConfig, 'apiCallTimeOut.eligiblityCall.customerMinTimeout'),
    max: get(appConfig, 'apiCallTimeOut.eligiblityCall.customerMaxTimeout'),
    clientOverallMax: get(
      appConfig,
      'apiCallTimeOut.eligiblityCall.clientOverallMaxTimeout'
    ),
  };
  const finalUri = `${apiDomain}/${apiEndpoint}`;
  const method = 'GET';
  // eslint-disable-next-line no-console
  console.log(`Making API call to ${finalUri} with method ${method}`);
  const { data, error } = useFetch({
    uri: finalUri,
    fetchOptions: {
      method,
      headers: () => {
        return createHeaders(headersDetails);
      },
    },
    timeoutOptions,
  });

  useEffect(() => {
    setEligibilityResponse({ data, error });
  }, [data, error]);
};

export default useEligibilityCall;
